import { Link } from "react-router-dom";

export default function TagSidebar({ tags = [] }) {
    if (!tags.length) return null;

    return (
        <aside className="sticky top-24">
            <div className="bg-white shadow rounded-lg overflow-hidden">

                {/* HEADER */}
                <div className="bg-[#0d4c8b] text-white px-4 py-3 font-semibold">
                    Popular Topics
                </div>

                {/* TAG LIST */}
                <div className="p-4 flex flex-wrap gap-2">
                    {tags.map((tag) => {
                        const cleanTag = tag.replace(/^#/, "").trim();
                        const slug = cleanTag.toLowerCase().replace(/\s+/g, "-");
                        const displayTag = cleanTag.replace(/\b\w/g, (c) => c.toUpperCase());

                        return (
                            <Link
                                key={slug}
                                to={`/tag/${slug}`}
                                className="
                  text-sm
                  bg-blue-100 text-blue-700
                  hover:bg-blue-200 hover:text-blue-900
                  px-3 py-1
                  rounded-md     /* ✅ SQUARE */
                  border border-blue-200
                  transition
                "
                            >
                                {displayTag}
                            </Link>
                        );
                    })}
                </div>

            </div>
        </aside>
    );
}
